module.exports = __webpack_public_path__ + "img/ic_preview.70e85bee.svg";